import { useMutation } from '@tanstack/react-query';

import { requestAccess } from './api';
import type { RequestAccessPayload } from './types';

export const useRequestAccess = () =>
  useMutation({
    mutationFn: (data: RequestAccessPayload) => requestAccess(data),
    // No retry: the endpoint is not idempotent, and its dedupe check would turn
    // a retried request into a spurious 409.
    retry: 0
  });
